import axios from "axios";
import type { DownloadAuthorData } from "./data/downloadAuthorData.ts";
import type { DownloadData } from "./data/downloadData.ts";
import type { DownloadKindData } from "./data/downloadKindData.ts";
import type { MenuData } from "./data/menuData.ts";
import type { PageData } from "./data/pageData.ts";
import type { PersonData } from "./data/personData.ts";
import type { ProductData } from "./data/productData.ts";
import { getEnv } from "./helpers/env.ts";

export async function fetchMenuByUrl(url: string): Promise<MenuData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/menu/' + url)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, url);
			}
		});
}

export async function fetchMenuById(id: number): Promise<MenuData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/menu/' + id)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, id);
			}
		});
}

export async function fetchPageByUrl(url: string): Promise<PageData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/page/url', {params: {url: url}})
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, url);
			}
		});
}

export async function fetchPageById(id: number): Promise<PageData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/page/' + id)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, id);
			}
		});
}

export async function fetchProductByUrl(url: string): Promise<ProductData> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/product/url', {params: {url: url}})
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, url);
			}
		});
}

export async function fetchPersonById(id: number): Promise<PersonData> {
	return axios.get('/api/person/' + id)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, id);
			}
		});
}

export async function fetchDownloadById(id: number): Promise<DownloadData> {
	return axios.get('/api/download/' + id)
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status + ':', error.config.url, id);
			}
		});
}

export async function fetchDownloads(): Promise<DownloadData[]> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/downloads')
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status);
			}
		});
}

export async function fetchDownloadKinds(): Promise<DownloadKindData[]> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/downloadKinds')
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status);
			}
		});
}

export async function fetchDownloadAuthors(): Promise<DownloadAuthorData[]> {
	return axios.get(getEnv('PUBLIC_API_HOST') + '/api/downloadAuthors')
		.then(async (response) => {
			return response.data;
		}).catch(function (error) {
			if (error.response && error.config) {
				console.log('Axios ' + error.response.status);
			}
		});
}
